import React from "react";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack"; // Importing MUI icon

const Header = ({ title }) => {
  const navigate = useNavigate();

  return (
    <header style={{ display: "flex", alignItems: "center", padding: "10px" }}>
      <ArrowBackIcon
        onClick={() => navigate(-1)}
        style={{
          fontSize: "1.5rem",
          cursor: "pointer",
          marginRight: "10px",
        }}
      />
      <h1 style={{ margin: 0, fontSize: "1.5rem" }}>{title}</h1>
    </header>
  );
};

export default Header;
